export { SelecionarLocalMapa } from './SelecionarLocalMapa'
